<app-page-layout>
  <h1>Queue Dashboard</h1>
  <p class="intro">
    Live operational view of queue and worker health. This dashboard pauses polling while the tab is hidden.
  </p>

  <app-queue-stats [showDetails]="true" [compact]="false" title="Backend Queue & Worker Stats" />
</app-page-layout>
